module.exports = __webpack_public_path__ + "img/q.c84d01e8.svg";